import { Navigate, useLocation } from "react-router-dom";

import { readToken } from "@/lib/tokenStore";

export default function JourneyGuard({ children }) {
  const location = useLocation();
  const token = readToken();
  if (!token) {
    return (
      <Navigate
        to="/admin"
        replace
        state={{ from: location.pathname }}
      />
    );
  }
  return children;
}
